import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxStart } from '../hooks/Common'
import { redirectPage } from '../hooks/auth'
import { saveFeedback } from '../hooks/question'
import Alert from './alert'
import FeedbackPopup from './FeedbackPopup'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet';


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    common: state.common,
    feedback: state.feedback
  }
}

const mapDispatchToProps = dispatch => ({
  reduxStart: () => dispatch(reduxStart()),
  redirectPage: () => dispatch(redirectPage()),
  saveFeedback: (data, userId) => dispatch(saveFeedback(data, userId))
});

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

const getLoginPath = (auth) => {
  var user = auth.user
  var path = "/logged-in"

  if (!user.essential_test) {
    path = "/onboarding-process"
  } else if (!auth.baseline) {
    path = "/self-assessment-complete"
  }
  return path
}

class RedirectPage extends PureComponent {

  constructor(props) {
    super(props);
    const page = window.location.pathname.split('/')
    this.state = {
      page: page.length === 3 ? page[2] : page[1],
      loggedIn: false,
      shouldNavigate: false,
      path: null,
      answer: "",
      feedbackQns: [],
      step: 1,
      count: 0
    };
    this.props.reduxStart()
  }


  componentDidMount = () => {

    this.componentCall()
    clearTimeout(this.timerLogin)
    this.timerLogin = setTimeout(() => {
      if (this.props.access_token && this.props.auth.access_token == null) {
        this.setState({
          shouldNavigate: true,
          path: "/login"
        })
      }
    }, 500)
  }

  componentDidUpdate = () => {
    this.componentCall()
    if (this.state.page !== "login" && this.props.auth.redirect_page === "log out") {
      this.props.redirectPage()
      this.handleRedirect("/login", true);
    }
    if (this.props.auth.redirect_page === "dashboard") {
      this.props.redirectPage()
      this.handleRedirect(this.props.auth.baseline ? "/dashboard" : "/alertness", true);
    }
    if (this.props.feedback.feedback_questions !== null && this.props.feedback.feedback_questions.length != this.state.feedbackQns.length) {
      this.setState({
        feedbackQns: this.props.feedback.feedback_questions,
        count: this.props.feedback.feedback_questions.length
      })
    }
  }
  componentCall() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      if (this.state.page === "login" && this.props.auth.access_token !== null) {
        this.handleRedirect(getLoginPath(this.props.auth), false)
      }
    }, 500)
  }

  handleRedirect = (path, time) => {
    if (time) {
      clearTimeout(this.timerRedirect)
      this.timerRedirect = setTimeout(() => {
        this.setState({ shouldNavigate: true, path })
      }, 500)
    } else {
      this.setState({ shouldNavigate: true, path })
    }

  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  handleFeedbackNext = () => {
    if (this.state.feedbackQns.length != this.state.step) {
      this.setState(prevState => {
        const feedbackQns = [...prevState.feedbackQns];
        feedbackQns[this.state.step - 1] = {
          ...feedbackQns[this.state.step - 1],
          answer: this.state.answer
        };

        return {
          feedbackQns,
          step: prevState.step + 1,
          answer: this.state.feedbackQns[prevState.step].answer != undefined ? this.state.feedbackQns[prevState.step].answer : ""
        };
      });
    } else {
      const feedbackQns = [...this.state.feedbackQns];
      feedbackQns[this.state.step - 1] = {
        ...feedbackQns[this.state.step - 1],
        answer: this.state.answer
      };

      this.props.saveFeedback(feedbackQns)
    }
  };


  handleFeedbackback = () => {
    this.setState({
      step: this.state.step - 1,
      answer: this.state.feedbackQns[this.state.step - 2].answer != undefined ? this.state.feedbackQns[this.state.step - 2].answer : ""
    })
  }

  render() {

    console.log(this.state, "RedirectPage")
    return <Fragment>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Alert />
      {this.state.feedbackQns.length > 0 && this.props.feedback.feedback_enable && this.props.feedback.showPopup ?
        <FeedbackPopup
          feedbackQns={this.state.feedbackQns}
          step={this.state.step}
          count={this.state.count}
          handleNext={this.handleFeedbackNext}
          handleFeedbackback={this.handleFeedbackback}
          answer={this.state.answer}
          handleChange={this.handleChange}
        />
        : null}

      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />
    </Fragment>
  }
}

RedirectPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectPage);
